import { trpc } from "../../../lib/api/trpc";
import type { DocumentQuota } from "../../../types/documents";

/**
 * Hook to fetch document quota information
 */
export const useDocumentQuota = () => {
  // @ts-ignore - Type checking for trpc.documents property
  const { data, isLoading, isError, error, refetch } =
    trpc.documents.getQuota.useQuery();

  return {
    quota: data as DocumentQuota | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
